export default "__VITE_ASSET__KYxGAEGs__"